export default "__VITE_ASSET__e057278a__"